import { render } from "./ContactSidebar.vue?vue&type=template&id=2404bf7c"
import script from "./ContactSidebar.vue?vue&type=script&lang=js"
export * from "./ContactSidebar.vue?vue&type=script&lang=js"

import "./ContactSidebar.vue?vue&type=style&index=0&id=2404bf7c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__